var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("range-slider", {
    staticClass: "x-range-slider",
    attrs: {
      id: "x-range-slider-" + _vm.name,
      min: _vm.min,
      max: _vm.max,
      step: _vm.step,
      name: _vm.name
    },
    model: {
      value: _vm.model,
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }